<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal" ref="loader"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text>
       <v-container grid-list-md class="py-0 px-0">            
          <v-layout wrap>
            <v-flex xs12 sm6 md4>
              <v-text-field
                label="PFI Name *"
                v-model="formSchema.pfi_name"
                :rules="[v => !!v || 'PFI name is required !',lng100]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field
                label="PFI Name (In Short) *"
                v-model="formSchema.short_name"
                :rules="[v => !!v || 'PFI name (In Short) is required !',lng6]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-autocomplete
                label="PFI Type *"
                v-model="formSchema.pfi_type"
                :items="pfiTypeList"
                :rules="[v => !!v || 'PFI type is required !',lng10]"
                required
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field label="PFI Address" v-model="formSchema.pfi_address"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field label="Phone" v-model="formSchema.pfi_phone" :rules="[rules.phoneNumber]"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field label="Fax" v-model="formSchema.pfi_fax" :rules="[faxNum]"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field label="PFI Email" v-model="formSchema.pfi_email" 
              :rules="[email]"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'maf_sign_date', fieldValue:formSchema.maf_sign_date, label:'MFA Sign Date *',required:1}"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

            <v-flex xs12 sm6 md4>
              <v-checkbox v-model="formSchema.is_active" label="Active" :value="isActiveVal"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="checkFormValidation" :disabled="!valid">
        <v-icon>save</v-icon>
        {{addUpdateBtn}}
      </v-btn>
      <v-btn color="error" @click="close">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn color="primary" @click="nextStep">
        Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
    </v-card-actions>

    <v-card-title>
      <h2>PFI Information</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.pfi_name }}</td>
        <td class="text-xs-left">{{ props.item.short_name }}</td>
        <td class="text-xs-left">{{ props.item.pfi_type }}</td>
        <!-- <td class="text-xs-left">{{ props.item.pfi_address }}</td> -->
        <td class="text-xs-left">{{ props.item.pfi_phone }}</td>
        <!-- <td class="text-xs-left">{{ props.item.pfi_fax }}</td>
        <td class="text-xs-left">{{ props.item.pfi_email }}</td> -->

        <td class="text-xs-left">
          <span v-if="props.item.is_active" class="active">Yes</span>
          <span v-else class="in-active">No</span>
        </td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
import DatePicker from "../../../global/date_picker";
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      valid: true,
      e1: 0,
      isActiveVal: 1,
      pfiTypeList: ["Bank", "Non-Bank"],

      delete_id: "",
      row_index: "",
      dialog2: false,

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

      formSchema: {
        id: 0,
        pfi_name: "",
        short_name: "",
        pfi_type: "",
        pfi_address: "",
        pfi_phone: "",
        pfi_fax: "",
        pfi_email: "",
        maf_sign_date:"",
        is_active: ""
      },

      /*------------- Datatable ---------------*/
      serialNumber: 0,
      sort: "",
      queryData: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
        search_val: ""
      },

      search: "",
      totalDesserts: 0,
      desserts: [],
      loading: true,
      pagination: {},

      headers: [
        {
          text: "SL",
          value: ""
        },
        {
          text: "PFI Name",
          align: "left",
          sortable: true,
          value: "pfi_name"
        },
        {
          text: "PFI Name (In Short)",
          align: "left",
          sortable: true,
          value: "short_name"
        },
        {
          text: "PFI Type",
          align: "left",
          sortable: true,
          value: "pfi_type"
        },
        /*{
          text: "Address",
          align: "left",
          sortable: true,
          value: "pfi_address"
        },*/
        {
          text: "Phone",
          align: "left",
          sortable: true,
          value: "pfi_phone"
        },
        /*{
          text: "Fax",
          align: "left",
          sortable: true,
          value: "pfi_fax"
        },
        {
          text: "Email",
          align: "left",
          sortable: true,
          value: "pfi_email"
        },*/
        {
          text: "Active",
          align: "left",
          sortable: true,
          value: "is_active"
        },

        { text: "Action", align: "center", value: "" }
      ],
      /*------------- /Datatable ---------------*/

      rules: {
      phoneNumber: (v) => {
        // const pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{5})$/;
        // return pattern.test(value) || "Enter valid phone no.";
        if (v && v.length > 0) {
          return (
            /(\+)?^[+0-9\(\)_.-]*$/.test(v) ||
            "Phone no. must be valid"
          );
        } else {
          return true;
        }
      },
    },

    };
  },

  created()
  {
    sessionStorage.removeItem('PfiShortName')
  },
  
  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },
  /*------------/Datatable------------*/

  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "pfi-information-list")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    checkFormValidation() {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {
      
      this.$refs.loader.loaderEnabled();

      let $this = this;
      let formSchema = this.formSchema;
      formSchema.maf_sign_date = this.changeFormateYMD(
        this.formSchema.maf_sign_date
      );

      let saveUpdate = 'insertFormData';
      if(formSchema.id>0)
      {
        saveUpdate = 'updateFormData';
      }

      commonService[saveUpdate](formSchema, "pfi-information")
        .then(res => {

          if (res.status == 1) {
            sessionStorage.setItem("PfiShortName", res.data.id);
            if (res.action == "update") {
              this.$set(this.desserts, this.row_index, { ...res.data });
            } else {
              $this.desserts.unshift({ ...res.data });
            }
            $this.SnackbarVal.message = res.message;
            $this.SnackbarVal.snackbar = true;
            $this.SnackbarVal.color = "success";       

            $this.close();

            window.scrollTo({
              left: 0,
              top:
                document.body.scrollHeight ||
                document.documentElement.scrollHeight,
              behavior: "smooth"
            });
          } else {
            $this.SnackbarVal.message = res.message;
            $this.SnackbarVal.snackbar = true;
            $this.SnackbarVal.color = "error";   
            // $this.message = res.message;
            // $this.snackbar = true;
          }
        });
    },

    nextStep() {
      //this.$emit("emitForm1", 2);

      let PFIshortName = sessionStorage.getItem("PfiShortName")
      if(PFIshortName){        
        this.$emit("emitForm1", 2);
      }
      else
      {
        this.SnackbarVal.color = "error";         
        this.SnackbarVal.message = "Select the row you want to edit.";
        this.SnackbarVal.snackbar = true;
      }

    },

    previous() {
      sessionStorage.removeItem('PfiShortName');
      this.$emit("emitForm1", 1);
    },

    editItem(index, item) {

      sessionStorage.setItem("PfiShortName", item.id);

      this.row_index = index;
      this.formSchema = { ...item };
      this.formSchema.maf_sign_date = this.changeFormateDMY(
          this.formSchema.maf_sign_date
        );
      this.scrollPage(0, 100); //set top, left position value
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "pfi-information").then(res => {
        this.SnackbarVal.color = "error";  
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
          this.SnackbarVal.color = "success";  
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close: function() {
      sessionStorage.removeItem('PfiShortName');
      this.formSchema.id = 0;
      this.formSchema.maf_sign_date = '';
      this.$refs.form.reset();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/lending/PFI/step_forms/pfiInformation.vue